import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shared-filter',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyPrimeNGModule,
    SidebarModule,
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './shared-filter.component.html',
  styleUrl: './shared-filter.component.scss'
})
export class SharedFilterComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() fields: FormlyFieldConfig[] = [];
  @Input() model: any = {};
  @Input() title: string = 'FILTER.FILTER';
  @Input() showClearButton: boolean = true;
  @Input() showApplyButton: boolean = true;
  @Input() clearButtonText: string = 'FILTER.CLEAR';
  @Input() applyButtonText: string = 'FILTER.APPLY';
  @Input() position: 'left' | 'right' | 'auto' = 'auto';
  @Input() width: string = '350px';

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() applyFilter = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<void>();
  @Output() modelChange = new EventEmitter<any>();

  form = new FormGroup({});
  formOptions = {};
  private translate = inject(TranslateService);

  ngOnInit(): void {
    // Initialize form if fields are provided
    if (this.fields && this.fields.length > 0) {
      this.initializeForm();
    }
  }

  get sidebarPosition(): 'left' | 'right' {
    if (this.position !== 'auto') {
      return this.position;
    }

    // Auto-detect position based on current language
    const currentLang = this.translate.currentLang || this.translate.getDefaultLang();
    return currentLang === 'ar' ? 'left' : 'right';
  }

  private initializeForm(): void {
    // Create a new form group for the filter fields
    this.form = new FormGroup({});

    // Set form options for better control
    this.formOptions = {
      formState: {
        disabled: false,
      },
    };
  }

  onApply(): void {
    if (this.form.valid) {
      const formValues = this.form.value;
      this.applyFilter.emit(formValues);
      this.closeSidebar();
    }
  }

  onClear(): void {
    // Reset form values
    this.form.reset();
    this.model = {};
    this.modelChange.emit(this.model);
    this.clearFilter.emit();
  }

  onModelChange(model: any): void {
    this.model = model;
    this.modelChange.emit(model);
  }

  closeSidebar(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  // Method to dynamically update fields (useful for dynamic filters)
  updateFields(newFields: FormlyFieldConfig[]): void {
    this.fields = newFields;
    this.initializeForm();
  }

  // Method to set initial model values
  setModelValues(values: any): void {
    this.model = { ...this.model, ...values };
    this.form.patchValue(values);
  }

  // Method to reset the filter completely
  resetFilter(): void {
    this.onClear();
    this.closeSidebar();
  }
}
